module.exports = __webpack_public_path__ + "static/media/EMB.c1dc6d1d.png";